import { create } from 'zustand';
import type { BufferCode } from '../api/marking';
import type { BarcodeProduct } from '../api/barcodeScans';

export interface ScanTargetResult {
  ok: boolean;
  message?: string;
  key?: string;
  duplicate?: boolean;
}

type MarkHandler = (scan: BufferCode) => Promise<ScanTargetResult> | ScanTargetResult;
type BarcodeHandler = (product: BarcodeProduct) => Promise<ScanTargetResult> | ScanTargetResult;

interface ScanTargetState {
  label: string | null;
  handler: MarkHandler | null;
  barcodeHandler: BarcodeHandler | null;
  orderId: number | null;
  orderNumber: string | null;
  markingCodes: Set<string>;
  setTarget: (
    label: string,
    handler: MarkHandler,
    orderId: number | null,
    orderNumber: string | null,
    barcodeHandler: BarcodeHandler
  ) => void;
  setMarkingCodes: (codes: Set<string>) => void;
  clearTarget: () => void;
}

const useScanTargetStore = create<ScanTargetState>((set) => ({
  label: null,
  handler: null,
  barcodeHandler: null,
  orderId: null,
  orderNumber: null,
  markingCodes: new Set(),
  setTarget: (label, handler, orderId, orderNumber, barcodeHandler) =>
    set({ label, handler, orderId, orderNumber, barcodeHandler }),
  setMarkingCodes: (codes) => set({ markingCodes: codes }),
  clearTarget: () => set({
    label: null,
    handler: null,
    barcodeHandler: null,
    orderId: null,
    orderNumber: null,
    markingCodes: new Set(),
  }),
}));

export default useScanTargetStore;
